import { Flex, Heading, Button, Link, Box, Image } from '@chakra-ui/react';

const Navbar = () => {
    return (
        <Flex as="nav" position="sticky" top="0" bg="white" boxShadow="sm" zIndex="sticky" p={4} justifyContent="center">
            <Flex gap={4}>
                <Button as="a" href="https://www.grahamcrackerstudios.com" variant="ghost" colorScheme="blue">Main Page</Button>
                <Button as="a" href="#faq" variant="ghost" colorScheme="blue">FAQ</Button>
                {/*<Button as="a" href="#support" variant="ghost" colorScheme="blue">Contact Support</Button>*/}
            </Flex>
        </Flex>
    );
};

export default Navbar;